import { Link } from "react-router";

import { PageHeader } from "../components/shell/AppShell";
import { EmptyState } from "../components/ui/Feedback";

export function NotFoundPage() {
  return (
    <div className="page">
      <PageHeader title="Sayfa bulunamadı" />
      <EmptyState
        action={
          <Link className="button button--secondary" to="/genel-bakis">
            Genel Bakış’a dön
          </Link>
        }
        body="Adres değişmiş veya bu kurulumda hiç var olmamış olabilir."
        heading="Aradığınız sayfa bulunamadı"
      />
    </div>
  );
}
